<template>
  <v-list two-line subheader style="background-color: inherit">
    <v-list-tile v-for="(message, key) in messages" :key="key" avatar>
      <v-list-tile-avatar>
        <v-icon class="primary">fa-envelope</v-icon>
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-title class="break-all">{{
          message.message
        }}</v-list-tile-title>
        <v-list-tile-sub-title>
          <span class="text--primary">{{ message.voter.full_name }}</span>
          &mdash; {{ message.created_at | dateTime }}
        </v-list-tile-sub-title>
      </v-list-tile-content>

      <v-list-tile-action v-if="message.archived === false">
        <v-btn icon ripple @click.stop="$emit('message-to-archive', message)">
          <v-icon color="grey lighten-1">fa-archive</v-icon>
        </v-btn>
      </v-list-tile-action>

      <v-list-tile-action v-else>
        <v-btn icon ripple @click.stop="$emit('message-from-archive', message)">
          <v-icon color="grey lighten-1">fa-undo</v-icon>
        </v-btn>
      </v-list-tile-action>

      <v-list-tile-action>
        <v-btn icon ripple @click.stop="$emit('message-delete', message)">
          <v-icon color="grey lighten-1">fa-trash</v-icon>
        </v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    messages: Array,
  },

  filters: {
    dateTime: function (value) {
      if (!value) return ''
      return moment(value).format('DD/MM/YYYY HH:mm')
    },
  },
}
</script>

<style scoped>
/* Sets list item height to auto, and applies padding for better fitment. */
.v-list--two-line >>> .v-list__tile {
  height: auto !important;
  padding: 8px 16px;
  min-height: 72px;
}

/* Sets list item title height to auto and wraps the title. */
.v-list--two-line .v-list__tile__title {
  white-space: normal;
  height: auto;
  min-height: 24px;
}

/* Wraps the subtitle. */
.v-list--two-line >>> .v-list__tile__sub-title {
  white-space: normal;
}
</style>
